export const GUEST_USERS = '/guest-users'
export const GUEST_PROFILE = '/st/certificates'
